<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useLoadingStore } from '@/shared/stores/loading';

/**
 * PQ-002 — a single indicator, driven by the API client's in-flight counter, so every
 * backend call produces visible feedback without each screen wiring up its own.
 *
 * A top bar rather than a blocking overlay: it communicates activity without taking the
 * interface away from the user (PQ-009).
 */
const { isLoading } = storeToRefs(useLoadingStore());
</script>

<template>
  <div
    class="pointer-events-none fixed inset-x-0 top-0 z-50 h-1"
    role="status"
    aria-live="polite"
  >
    <Transition
      enter-active-class="transition-opacity duration-150"
      leave-active-class="transition-opacity duration-300"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isLoading"
        class="h-full overflow-hidden bg-brand-100"
      >
        <div class="h-full w-1/3 animate-[loading_1.1s_ease-in-out_infinite] bg-brand-500" />
      </div>
    </Transition>
    <span class="sr-only">{{ isLoading ? 'Procesando solicitud' : '' }}</span>
  </div>
</template>

<style>
@keyframes loading {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
}
</style>
